import {Colors} from '@wandb/common/css/globals.styles';
import styled from 'styled-components';

import {IconLightbulbInfo} from '../../../Icon';

export const Panel = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 40px;
`;

export const OffsetUp = styled.div`
  position: relative;
  top: -64px;
`;

export const Circle = styled.div`
  border-radius: 50%;
  width: 96px;
  height: 96px;
  background-color: ${Colors.SIENNA_TRANSPARENT};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
`;

export const LightBulb = styled(IconLightbulbInfo)`
  width: 36px;
  height: 48px;
  color: ${Colors.SIENNA_DARK};
`;

export const Heading = styled.div`
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 8px;
`;

export const Message = styled.div`
  text-align: center;
  font-weight: 400px;
  font-size: 18px;
  line-height: 25.2px;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;
